module.exports = __webpack_public_path__ + "img/mfu_logo.3c4020de.png";